<template>
  <div id="error-modal" ref="content">
    <div class="content-section">
      <div class="text" v-html="text"></div>
      <div class="errors">
        <div
          v-for="(item, index) in getErrorMessage.endpoints.length"
          :key="index"
          style="margin-bottom: 15px, border-bottom: 1px solid rgba(0,0,0,0.2)"
        >
          <div
            style="color: red; text-align: center; margin-bottom: 10px; word-break: break-word;"
          >
            {{ getErrorMessage.endpoints[index] }} <br />
            {{ getErrorMessage.messages[index].message }}
          </div>
          <div class="divider"></div>
        </div>
      </div>
    </div>
    <div class="footer-section">
      <div class="text-center">
        <rounded-button width="100%" class="button" @click="reloadPage">
          <div v-html="okText"></div>
        </rounded-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ErrorHandlerModal",
  props: {
    text: {
      type: String,
      required: true
    },
    okText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      counter: 5,
      interval: undefined
    };
  },
  mounted() {
    if (this.getErrorMessage.required === false) {
      this.$eventBus.closeModal();
    }
  },
  beforeDestroy() {
    this.removeErrorMessage();
  },
  methods: {
    ...mapActions({
      removeErrorMessage: "errorHandler/removeErrorMessage"
    }),
    reloadPage() {
      location.reload();
    }
  },
  computed: {
    ...mapGetters({
      getErrorMessage: "errorHandler/getErrorMessage"
    })
  }
};
</script>
<style lang="scss" scoped>
#error-modal {
  width: 100%;
  padding: 10px;
  .content-section {
    .text {
      text-align: center;
      font-size: 16px;
      word-break: break-word;
      line-height: 1.8rem;
      margin-bottom: 15px;
    }
    .divider {
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }
  .footer-section {
    .button {
      height: 35px;
      width: 150px;
      padding: 0 !important;
    }
  }
}
</style>
